export const EMAIL = 'email'
export const FIRST_NAME = 'firstName'
export const LAST_NAME = 'lastName'
export const COUNTRY = 'country'
export const CITY = 'city'
export const STREET = 'street'
export const POSTAL_CODE = 'postalCode'
export const MOBILE_PHONE = 'mobilePhone'
